module.exports = __webpack_public_path__ + "static/media/own-customize-icon.709299af.svg";